import { Question } from '../models/value_meter_question'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'

export const getRebuildValueMeterForm = async () =>
  await Api<IApiResponse<Record<string, Question>>>('GET', 'question-list-value-meters/rebuild-value', BaseUrl.Request)

export const getHouseholdValueMeterForm = async () =>
  await Api<IApiResponse<Record<string, Question>>>('GET', 'question-list-value-meters/home-contents', BaseUrl.Request)
